export default class AnchorButtons {
    constructor() {
        this.buttons = document.querySelectorAll('.link--anchor')
        this.rotateAfterIfTargetIsAboveButton()
    }

    rotateAfterIfTargetIsAboveButton() {
        this.buttons.forEach((button) => {
            if (!button.href || this.isLinkExternal(button.href)) return
            let targetElement = this.getTargetElementByHref(button.href)
            if (!targetElement) return
            let buttonPosition = button.getBoundingClientRect().top
            let targetPosition = targetElement.getBoundingClientRect().top
            if (targetPosition < buttonPosition) {
                button.classList.add('btn--rotate-after')
            }
        })
    }

    getTargetElementByHref(href) {
        let url = new URL(href)
        return document.querySelector(url.hash)
    }

    isLinkExternal(href) {
        let url = new URL(href)
        return url.host !== window.location.host
    }
}
